// extracted by mini-css-extract-plugin
export var actions = "_2g-0";
export var actionsContainer = "_2g-7";
export var border = "_2g-1";
export var childFullHeight = "_2g-g";
export var collapse = "_2g-2";
export var content = "_2g-b";
export var contentChild = "_2g-f";
export var fullscreen = "_2g-d";
export var hasLeftRadius = "_2g-l";
export var headerContainer = "_2g-3";
export var headerRow = "_2g-5";
export var hidePadding = "_2g-c";
export var navCollapsedGap = "_2g-m";
export var noScrollX = "_2g-n";
export var noScrollY = "_2g-o";
export var noTopPadding = "_2g-j";
export var optOutTopPadding = "_2g-e";
export var pageMain = "_2g-k";
export var pageOuter = "_2g-h";
export var pagePadding = "_2g-8";
export var pageScroll = "_2g-9";
export var profile = "_2g-p";
export var profileContainer = "_2g-q";
export var profileImage = "_2g-r";
export var profileMain = "_2g-s";
export var profileSubtitle = "_2g-u";
export var profileTitle = "_2g-t";
export var settingsSurface = "_2g-a";
export var showLeftPadding = "_2g-i";
export var tabsPortalSlot = "_2g-6";
export var tabsWrapper = "_2g-4";
export var title = "_2g-v";